var _excluded = ["size", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type"],
  _excluded2 = ["as"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["label", "value", "selected", "disabled", "onClick", "borderRadius", "buttonType", "primary"],
  _excluded8 = ["children", "value", "onChange", "borderRadius", "compact", "name", "buttonType", "reset", "onReset"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsxs as E, jsx as l } from "react/jsx-runtime";
import { forwardRef as u, useMemo as j, Children as m, isValidElement as y, cloneElement as I } from "react";
import { css as w, styled as c } from "styled-components";
var A = {
    xLarge: "\n    padding: 16px 40px;\n    font-size: 20px;\n    line-height: 32px;\n  ",
    large: "\n    padding: 16px 30px;\n    font-size: 18px;\n    line-height: 24px;\n  ",
    medium: "\n    padding: 12px 22px;\n    font-size: 16px;\n    line-height: 24px;\n  ",
    small: "\n    padding: 8px 20px;\n    font-size: 14px;\n    line-height: 24px;\n  ",
    xSmall: "\n    padding: 8px 16px;\n    font-size: 12px;\n    line-height: 16px;\n  "
  },
  L = c.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-disabled-text-color: ", ";\n  --button-bg-color: ", ";\n  --button-hover-bg-color: ", ";\n  --button-disabled-bg-color: ", ";\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  cursor: pointer;\n  outline: none;\n  white-space: nowrap;\n  user-select: none;\n  height: fit-content;\n  font-family: inherit;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  color: var(--button-text-color);\n  background: var(--button-bg-color);\n\n  [data-name='hn-icon'] {\n    fill: var(--button-text-color);\n  }\n\n  ", ";\n\n  &:focus-visible {\n    outline: auto;\n    background: var(--button-hover-bg-color);\n    color: var(--button-hover-text-color);\n\n    [data-name='hn-icon'] {\n      fill: var(--button-hover-text-color);\n    }\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: var(--button-hover-bg-color);\n      color: var(--button-hover-text-color);\n\n      [data-name='hn-icon'] {\n        fill: var(--button-hover-text-color);\n      }\n    }\n  }\n\n  &:disabled {\n    background: var(--button-disabled-bg-color);\n    color: var(--button-disabled-text-color);\n    cursor: not-allowed;\n\n    [data-name='hn-icon'] {\n      fill: var(--button-disabled-text-color);\n    }\n  }\n\n  ", ";\n"])), function (_ref) {
    var o = _ref.theme;
    return o.colors.black100;
  }, function (_ref2) {
    var o = _ref2.theme;
    return o.colors.black100;
  }, function (_ref3) {
    var o = _ref3.theme;
    return o.colors.black100;
  }, function (_ref4) {
    var o = _ref4.theme;
    return o.colors.blue60;
  }, function (_ref5) {
    var o = _ref5.theme;
    return o.colors.blue50;
  }, function (_ref6) {
    var o = _ref6.theme;
    return o.colors.black80;
  }, function (_ref7) {
    var _A$o;
    var o = _ref7.size;
    return (_A$o = A[o]) !== null && _A$o !== void 0 ? _A$o : A.small;
  }, function (_ref8) {
    var o = _ref8.$fit;
    return o && w(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      width: fit-content;\n      height: fit-content;\n    "])));
  }),
  T = c.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  & > svg {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"])), function (_ref9) {
    var o = _ref9.$margin,
      t = _ref9.$position;
    return t === "left" ? 0 : "".concat(o, "px");
  }, function (_ref10) {
    var o = _ref10.$margin,
      t = _ref10.$position;
    return t === "right" ? 0 : "".concat(o, "px");
  }),
  C = function C(_ref11) {
    var o = _ref11.position,
      t = _ref11.Icon,
      r = _ref11.size;
    var i = W[r],
      a = ["small", "xSmall"].includes(r) ? 4 : 8;
    return t ? /* @__PURE__ */l(T, {
      $position: o,
      $margin: a,
      children: /* @__PURE__ */l(t, {
        size: i
      })
    }) : null;
  },
  p = /*#__PURE__*/u(function (_ref12, h) {
    var _ref12$size = _ref12.size,
      o = _ref12$size === void 0 ? "medium" : _ref12$size,
      _ref12$disabled = _ref12.disabled,
      t = _ref12$disabled === void 0 ? !1 : _ref12$disabled,
      r = _ref12.onClick,
      i = _ref12.children,
      a = _ref12.LeftIcon,
      b = _ref12.RightIcon,
      s = _ref12.tabIndex,
      _ref12$fit = _ref12.fit,
      n = _ref12$fit === void 0 ? !1 : _ref12$fit,
      x = _ref12.name,
      d = _ref12.value,
      f = _ref12.className,
      _ref12$type = _ref12.type,
      e = _ref12$type === void 0 ? "button" : _ref12$type,
      $ = _objectWithoutProperties(_ref12, _excluded);
    return /* @__PURE__ */E(L, _objectSpread(_objectSpread({
      size: o,
      disabled: t,
      onClick: r,
      tabIndex: s,
      $fit: n,
      name: x,
      value: d,
      className: f,
      type: e,
      ref: h
    }, $), {}, {
      children: [/* @__PURE__ */l(C, {
        Icon: a,
        size: o,
        position: "left"
      }), i, /* @__PURE__ */l(C, {
        Icon: b,
        size: o,
        position: "right"
      })]
    }));
  }),
  W = {
    xLarge: 32,
    large: 32,
    medium: 24,
    small: 16,
    xSmall: 16
  },
  M = c(p)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-bg-color: ", ";\n  --button-hover-bg-color: ", ";\n"])), function (_ref13) {
    var o = _ref13.theme;
    return o.colors.black100;
  }, function (_ref14) {
    var o = _ref14.theme;
    return o.colors.black100;
  }, function (_ref15) {
    var o = _ref15.theme;
    return o.colors.blue60;
  }, function (_ref16) {
    var o = _ref16.theme;
    return o.colors.blue50;
  }),
  G = /*#__PURE__*/u(function (_ref17, r) {
    var o = _ref17.as,
      t = _objectWithoutProperties(_ref17, _excluded2);
    return /* @__PURE__ */l(M, _objectSpread({
      ref: r,
      forwardedAs: o
    }, t));
  }),
  N = c(p)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  --button-bg-color: ", ";\n  --button-hover-bg-color: ", ";\n"])), function (_ref18) {
    var o = _ref18.theme;
    return o.colors.darkBlue40;
  }, function (_ref19) {
    var o = _ref19.theme;
    return o.colors.darkBlue30;
  });
/*#__PURE__*/u(function (o, t) {
  return /* @__PURE__ */l(N, _objectSpread({
    ref: t
  }, o));
});
var P = c(p)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  --button-bg-color: ", ";\n  --button-hover-bg-color: ", ";\n"])), function (_ref20) {
  var o = _ref20.theme;
  return o.colors.purple40;
}, function (_ref21) {
  var o = _ref21.theme;
  return o.colors.purple30;
});
/*#__PURE__*/u(function (o, t) {
  return /* @__PURE__ */l(P, _objectSpread({
    ref: t
  }, o));
});
var D = c(p)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-disabled-text-color: ", ";\n  --button-bg-color: transparent;\n  --button-hover-bg-color: transparent;\n  --button-disabled-bg-color: transparent;\n"])), function (_ref22) {
    var o = _ref22.theme;
    return o.colors.blue50;
  }, function (_ref23) {
    var o = _ref23.theme;
    return o.colors.blue30;
  }, function (_ref24) {
    var o = _ref24.theme;
    return o.colors.black80;
  }),
  O = /*#__PURE__*/u(function (o, t) {
    return /* @__PURE__ */l(D, _objectSpread({
      ref: t
    }, o));
  }),
  U = c(O)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 0;\n  border-radius: 0;\n"]))),
  V = /*#__PURE__*/u(function (o, t) {
    return /* @__PURE__ */l(U, _objectSpread({
      ref: t
    }, o));
  }),
  q = c(p)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-disabled-text-color: ", ";\n  --button-bg-color: transparent;\n  --button-hover-bg-color: transparent;\n  --button-disabled-bg-color: transparent;\n\n  padding: 0;\n"])), function (_ref25) {
    var o = _ref25.theme;
    return o.colors.blue60;
  }, function (_ref26) {
    var o = _ref26.theme;
    return o.colors.blue50;
  }, function (_ref27) {
    var o = _ref27.theme;
    return o.colors.black80;
  });
/*#__PURE__*/u(function (_ref28, r) {
  var o = _ref28.children,
    t = _objectWithoutProperties(_ref28, _excluded3);
  return /* @__PURE__ */l(q, _objectSpread(_objectSpread({
    ref: r,
    "aria-label": "icon-button"
  }, t), {}, {
    fit: !0,
    children: o
  }));
});
var H = c(p)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-disabled-text-color: ", ";\n  --button-bg-color: transparent;\n  --button-hover-bg-color: transparent;\n  --button-disabled-bg-color: transparent;\n\n  padding: 0;\n"])), function (_ref29) {
  var o = _ref29.theme;
  return o.colors.darkBlue40;
}, function (_ref30) {
  var o = _ref30.theme;
  return o.colors.darkBlue30;
}, function (_ref31) {
  var o = _ref31.theme;
  return o.colors.black80;
});
/*#__PURE__*/u(function (_ref32, r) {
  var o = _ref32.children,
    t = _objectWithoutProperties(_ref32, _excluded4);
  return /* @__PURE__ */l(H, _objectSpread(_objectSpread({
    ref: r
  }, t), {}, {
    fit: !0,
    children: o
  }));
});
var J = c(p)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-disabled-text-color: ", ";\n  --button-bg-color: transparent;\n  --button-hover-bg-color: transparent;\n  --button-disabled-bg-color: transparent;\n\n  padding: 0;\n"])), function (_ref33) {
  var o = _ref33.theme;
  return o.colors.purple40;
}, function (_ref34) {
  var o = _ref34.theme;
  return o.colors.purple30;
}, function (_ref35) {
  var o = _ref35.theme;
  return o.colors.black80;
});
/*#__PURE__*/u(function (_ref36, r) {
  var o = _ref36.children,
    t = _objectWithoutProperties(_ref36, _excluded5);
  return /* @__PURE__ */l(J, _objectSpread(_objectSpread({
    ref: r
  }, t), {}, {
    fit: !0,
    children: o
  }));
});
var K = c(p)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-bg-color: ", ";\n  --button-hover-bg-color: ", ";\n"])), function (_ref37) {
  var o = _ref37.theme;
  return o.colors.blue50;
}, function (_ref38) {
  var o = _ref38.theme;
  return o.colors.blue30;
}, function (_ref39) {
  var o = _ref39.theme;
  return o.colors.blue95;
}, function (_ref40) {
  var o = _ref40.theme;
  return o.colors.blue90;
});
/*#__PURE__*/u(function (o, t) {
  return /* @__PURE__ */l(K, _objectSpread({
    ref: t
  }, o));
});
var Q = c(p)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  --button-text-color: ", ";\n  --button-hover-text-color: ", ";\n  --button-disabled-text-color: ", ";\n  --button-bg-color: transparent;\n  --button-hover-bg-color: transparent;\n  --button-disabled-bg-color: transparent;\n\n  padding: 0;\n"])), function (_ref41) {
  var o = _ref41.theme;
  return o.colors.blue95;
}, function (_ref42) {
  var o = _ref42.theme;
  return o.colors.blue90;
}, function (_ref43) {
  var o = _ref43.theme;
  return o.colors.black80;
});
/*#__PURE__*/u(function (_ref44, r) {
  var o = _ref44.children,
    t = _objectWithoutProperties(_ref44, _excluded6);
  return /* @__PURE__ */l(Q, _objectSpread(_objectSpread({
    ref: r
  }, t), {}, {
    fit: !0,
    children: o
  }));
});
c(V)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n\n  ", ";\n"])), function (_ref45) {
  var o = _ref45.theme,
    t = _ref45.$danger;
  return t && w(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      --button-text-color: ", ";\n      --button-hover-text-color: ", ";\n    "])), o.colors.red60, o.colors.red40);
});
var X = c(G)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  padding: 8px 16px;\n\n  &[aria-pressed='true'] {\n    border-radius: ", ";\n\n    &:focus-visible {\n      outline: none;\n    }\n  }\n\n  &[aria-pressed='false'] {\n    --button-text-color: ", ";\n    --button-hover-text-color: ", ";\n    --button-bg-color: transparent;\n    --button-hover-bg-color: transparent;\n\n    &:focus-visible {\n      outline: none;\n    }\n\n    &:disabled {\n      color: ", ";\n      background-color: transparent;\n    }\n  }\n"])), function (_ref46) {
    var o = _ref46.$borderRadius;
    return "".concat(o, "px");
  }, function (_ref47) {
    var o = _ref47.theme;
    return o.colors.blue50;
  }, function (_ref48) {
    var o = _ref48.theme;
    return o.colors.blue30;
  }, function (_ref49) {
    var o = _ref49.theme;
    return o.colors.black60;
  }),
  z = function z(_ref50) {
    var o = _ref50.label,
      t = _ref50.value,
      _ref50$selected = _ref50.selected,
      r = _ref50$selected === void 0 ? !1 : _ref50$selected,
      _ref50$disabled = _ref50.disabled,
      i = _ref50$disabled === void 0 ? !1 : _ref50$disabled,
      a = _ref50.onClick,
      _ref50$borderRadius = _ref50.borderRadius,
      b = _ref50$borderRadius === void 0 ? 8 : _ref50$borderRadius,
      s = _ref50.buttonType,
      _ref50$primary = _ref50.primary,
      n = _ref50$primary === void 0 ? !1 : _ref50$primary,
      x = _objectWithoutProperties(_ref50, _excluded7);
    return /* @__PURE__ */l(X, _objectSpread(_objectSpread({
      "aria-pressed": r,
      onClick: function onClick() {
        !i && a && a(t);
      },
      $borderRadius: b,
      type: s,
      size: "medium",
      disabled: i,
      "data-primary": n
    }, x), {}, {
      children: o
    }));
  };
z.displayName = "Filter";
var k = {
    label: "All",
    value: "All",
    primary: !0
  },
  Y = c.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  background: ", ";\n  border-radius: ", ";\n  width: fit-content;\n  ", ";\n"])), function (_ref51) {
    var o = _ref51.theme;
    return o.colors.blue95;
  }, function (_ref52) {
    var o = _ref52.$borderRadius;
    return "".concat(o, "px");
  }, function (_ref53) {
    var o = _ref53.$compact;
    return !o && w(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      display: grid;\n      grid-auto-flow: column;\n      grid-auto-columns: 1fr;\n    "])));
  }),
  eo = function eo(_ref54) {
    var o = _ref54.children,
      t = _ref54.value,
      r = _ref54.onChange,
      _ref54$borderRadius = _ref54.borderRadius,
      i = _ref54$borderRadius === void 0 ? 8 : _ref54$borderRadius,
      _ref54$compact = _ref54.compact,
      a = _ref54$compact === void 0 ? !0 : _ref54$compact,
      _ref54$name = _ref54.name,
      b = _ref54$name === void 0 ? "filters" : _ref54$name,
      _ref54$buttonType = _ref54.buttonType,
      s = _ref54$buttonType === void 0 ? "button" : _ref54$buttonType,
      _ref54$reset = _ref54.reset,
      n = _ref54$reset === void 0 ? !1 : _ref54$reset,
      x = _ref54.onReset,
      d = _objectWithoutProperties(_ref54, _excluded8);
    var _R = R({
        reset: n,
        children: o
      }),
      f = _R.children,
      e = _R.reset,
      $ = Z({
        value: t,
        children: f,
        onChange: r,
        borderRadius: i,
        buttonType: s,
        reset: e,
        onReset: x
      });
    return /* @__PURE__ */E(Y, _objectSpread(_objectSpread({
      $borderRadius: i,
      $compact: a,
      role: "group"
    }, d), {}, {
      children: [/* @__PURE__ */l("input", {
        type: "hidden",
        name: b,
        value: t
      }), $]
    }));
  },
  Z = function Z(_ref55) {
    var o = _ref55.value,
      t = _ref55.children,
      r = _ref55.onChange,
      i = _ref55.borderRadius,
      a = _ref55.buttonType,
      b = _ref55.reset,
      s = _ref55.onReset;
    var n = [];
    var x = m.toArray(t).map(function (e) {
        if (! /*#__PURE__*/y(e)) throw new Error("Filters contains an unexpected child");
        return e.props.value;
      }),
      d = Array.isArray(o),
      f = [];
    return m.forEach(t, function (e) {
      /*#__PURE__*/y(e) && e.props.primary && f.push(e.props.value);
    }), m.map(t, function (e) {
      if (! /*#__PURE__*/y(e) || e.type.displayName !== "Filter") throw new Error("Filters contains an unexpected child");
      var h = (d ? o : [o]).includes(e.props.value);
      h && (d ? n.push(e.props.value) : n = [e.props.value]);
      var F = function F(g) {
        if (d) {
          n = n.filter(function (v) {
            return !f.includes(v);
          }), e.props.primary ? n = [g] : n.includes(g) ? new Set(n).size > 1 && (n = n.filter(function (v) {
            return v !== g;
          })) : n.push(g);
          var B = n.length === x.length - f.length,
            S = B ? f : n;
          r == null || r(S), (typeof b == "object" && g === b.value || B) && (s == null || s());
        } else r == null || r(g), typeof b == "object" && g === b.value && (s == null || s());
      };
      return /*#__PURE__*/I(e, _objectSpread(_objectSpread({
        buttonType: a
      }, e.props), {}, {
        selected: h,
        onClick: !h || d ? F : void 0,
        borderRadius: i
      }));
    });
  };
function R(_ref56) {
  var o = _ref56.reset,
    t = _ref56.children;
  var r = j(function () {
    return o === !0 ? _objectSpread({}, k) : typeof o == "object" ? _objectSpread(_objectSpread({}, k), o) : null;
  }, [o]);
  if (!r) return {
    children: t,
    reset: !1
  };
  var i = /* @__PURE__ */l(z, _objectSpread({}, r), k.value);
  return {
    children: Array.isArray(t) ? [i].concat(_toConsumableArray(t)) : [i, t],
    reset: r
  };
}
export { k as DEFAULT_FILTER_RESET, z as Filter, eo as Filters };